
import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

export const useSpotOwner = (ownerId: string) => {
  const [isOwner, setIsOwner] = useState(false);
  const [currentUser, setCurrentUser] = useState<string | null>(null);

  useEffect(() => {
    const getUser = async () => {
      const { data: { user } } = await supabase.auth.getUser();
      setCurrentUser(user?.id || null);
      setIsOwner(user?.id === ownerId);
    };
    getUser();
  }, [ownerId]);

  return { isOwner, currentUser };
};
